export default "__VITE_ASSET__CjzzjWcP__"